import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=afd7d7a4&scoped=true"
import script from "./privacyAgreement.vue?vue&type=script&lang=js"
export * from "./privacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=afd7d7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd7d7a4",
  null
  
)

export default component.exports